import React from 'react';
import { useTranslation } from '../i18n/index.jsx';
import { languages } from '../i18n/index.jsx';
import './LanguageToggle.css';

export default function LanguageToggle({ open, onToggle, onClose }) {
  const { lang, setLang } = useTranslation();

  const current = languages.find(l => l.code === lang) || languages[0];

  return (
    <div className="lang-wrapper">
      <button className="lang-toggle" onClick={onToggle}>
        {current.label}
      </button>

      {open && (
        <>
          <div className="lang-backdrop" onClick={onClose} />
          <div className="lang-dropdown">
            {languages.map(l => (
              <button
                key={l.code}
                className={`lang-option ${l.code === lang ? 'active' : ''}`}
                onClick={() => { setLang(l.code); onClose(); }}
              >
                <span className="lang-option-label">{l.label}</span>
                <span className="lang-option-name">{l.name}</span>
                {l.code === lang && <span className="lang-option-check">✓</span>}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
